import { PmInvestmentOrderStatusRev as S } from "./constant";

/**
 * What each choice of the Private Equity tab's status filter shows.
 *
 * "All" listed cancelled orders beside live ones, and the list carries every
 * order the client ever placed — so a reader who wanted what they hold had
 * to pick Intended, Binding and Committed one at a time. "Active" is those
 * three, exactly as its caption in the menu says. It is the tab's default,
 * as Open is the Smartfolios tab's. (REQUESTED_SELL is defined in cmt but
 * never set; it stays reachable under All.)
 */
export const PRIVATE_EQUITY_FILTERS: Record<string, string[]> = {
  ACTIVE: [S.INTENDED, S.BINDING, S.COMMITTED],
  INTENDED: [S.INTENDED],
  BINDING: [S.BINDING],
  COMMITTED: [S.COMMITTED],
  CANCELED: [S.CANCELED],
  ON_SELL: [S.ON_SELL],
};

export const DEFAULT_PRIVATE_EQUITY_FILTER = "ACTIVE";

/** The rows a filter shows; "ALL" (or a choice it does not know) shows every one. */
export const privateEquityRows = <T extends { status?: string }>(
  rows: T[],
  filter: string,
): T[] => {
  const statuses = PRIVATE_EQUITY_FILTERS[filter];
  return statuses
    ? rows.filter((row) =>
        statuses.includes(String(row?.status ?? "").toUpperCase()),
      )
    : rows;
};
